import { useBudgetContext } from '@/components/cashflow/budget/BudgetContext';
import { BUDGET_PURPOSE_TO_STEP_MAP } from '@/components/cashflow/budget/BudgetOnboardingContext';
import { showBudgetOnboardingModal } from '@/components/cashflow/budget/BudgetOnboardingModal';
import { Button } from '@/components/common/Button';
import { FlexRow } from '@/components/common/Flex';
import { Settings04 } from '@/components/common/icons';
import InputField from '@/components/common/InputField';
import { Text } from '@/components/common/Typography';
import { BudgetPurpose } from '@common/graphql/generated';
import { DATE_RANGE_TYPE_OPTIONS } from '@common/util/dateTime';

interface BudgetControlsProps {
    budgetPurpose?: BudgetPurpose;
    groupId?: string;
}

export const BudgetControls = ({
    budgetPurpose,
    groupId,
}: BudgetControlsProps) => {
    const { setDateRangeType, dateRangeType } = useBudgetContext();

    const initialStep = budgetPurpose
        ? BUDGET_PURPOSE_TO_STEP_MAP[budgetPurpose]
        : undefined;

    return (
        <FlexRow gap={4} align="center">
            <InputField
                name="date-range"
                type="fancySelect"
                onChange={({ value }) => {
                    setDateRangeType(value);
                }}
                fancySelectOptions={{
                    isClearable: false,
                }}
                inputProps={{
                    size: 'md',
                }}
                options={DATE_RANGE_TYPE_OPTIONS}
                value={dateRangeType}
                w="140px"
                tabIndex={-1}
            />
            {initialStep && (
                <Button
                    colorScheme="dark"
                    size="sm"
                    h={12}
                    onClick={() =>
                        showBudgetOnboardingModal({
                            variant: 'update',
                            initialStep,
                            autofocusGroupId: groupId,
                        })
                    }
                    onClickEvent="Edit Budget Button Clicked"
                >
                    <FlexRow gap={2}>
                        <Settings04 size="sm" />
                        <Text size="sm">Edit budget</Text>
                    </FlexRow>
                </Button>
            )}
        </FlexRow>
    );
};
